/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: useVoiceHelpers.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Helper functions for voice configuration labels.
────────────────────────────────────────────────────────────────*/

import { useI18n } from '../../../hooks/useI18n';

export function useVoiceHelpers() {
  const { t } = useI18n();

  const getPitchLabel = (value: number): string => {
    if (value <= -30) return t('aiProfiles.pitchLevels.veryLow');
    if (value <= -10) return t('aiProfiles.pitchLevels.low');
    if (value <= 10) return t('aiProfiles.pitchLevels.medium');
    if (value <= 30) return t('aiProfiles.pitchLevels.high');
    return t('aiProfiles.pitchLevels.veryHigh');
  };

  const getVolumeLabel = (value: number): string => {
    if (value === 0) return t('aiProfiles.volumeLevels.silent');
    if (value <= 50) return t('aiProfiles.volumeLevels.verySoft');
    if (value <= 75) return t('aiProfiles.volumeLevels.soft');
    if (value <= 125) return t('aiProfiles.volumeLevels.medium');
    if (value <= 175) return t('aiProfiles.volumeLevels.loud');
    return t('aiProfiles.volumeLevels.veryLoud');
  };

  const getRateLabel = (value: number): string => {
    if (value <= 0.7) return t('aiProfiles.rateLevels.verySlow');
    if (value <= 0.9) return t('aiProfiles.rateLevels.slow');
    if (value <= 1.3) return t('aiProfiles.rateLevels.medium');
    if (value <= 1.7) return t('aiProfiles.rateLevels.fast');
    return t('aiProfiles.rateLevels.veryFast');
  };

  return {
    getPitchLabel,
    getVolumeLabel,
    getRateLabel
  };
}

